"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OccupationIdPathParamsSchema = void 0;
// occupations.request.ts
const zod_1 = require("zod");
exports.OccupationIdPathParamsSchema = zod_1.z.object({ occupationId: zod_1.z.string() });
// export const OccupationListQuerySchema = PaginationQuerySchema.extend({
// 	parentId: z.string().optional(),
// 	locale:   z.string().optional(),
// 	search:   z.string().optional(),
// });
// export type OccupationListQuery = z.input<typeof OccupationListQuerySchema>;
